import CInstitutionSelect from './CInstitutionSelect'
export default CInstitutionSelect;